(function(){
/* Every DOM lookup goes through g(). Nothing in here may assume an element exists. */
function g(id){return document.getElementById(id);}
function el(t,s,h){var e=document.createElement(t);if(s)e.setAttribute('style',s);if(h!==undefined)e.innerHTML=h;return e;}

var P=window.IF_DESIGNS||[];
var V=window.IF_VARIANTS||[];
if(!P.length){var b0=g('if-add');if(b0){b0.onclick=function(){window.location.href='/products/ice-freaks-ski-mask';};}return;}

var BUNDLES=[
{qty:'1 MASK',per:'$26.00 each',price:'26.00',badge:null},
{qty:'2 MASKS',per:'$22.50 each',price:'45.00',badge:'MOST POPULAR'},
{qty:'3 MASKS',per:'$20.67 each',price:'62.00',badge:'BEST VALUE'}
];
var REVIEWS=[
['Tyler M.','5','Wore it on the gondola and a guy genuinely apologised to me for cutting the line. He thought I was 80.'],
['Danielle R.','5','Bought two for my brothers. We got filmed by three separate strangers before we even got on the lift.'],
['Jonas K.','5','Actually warm. That is the part nobody mentions. Stayed on all day at -12 and my face was fine.'],
['Priya S.','4','The seam sits a little high over the nose at first, sorts itself out after ten minutes. Comedy value is unmatched.'],
['Marcus D.','5','My ski instructor asked to borrow it. My ski instructor. That is the review.'],
['Owen B.','5','Fits under a helmet with no bulk and the goggles sit right over the eyes. Did not think that would work.']
];
var FAQS=[
['Does it actually fit under a helmet?','Yes. It is a thin four-way stretch knit, not fleece, so there is no bulk at the crown. Goggles sit straight over the eye openings.'],
['Is it warm enough for a real cold day?','It is a full-face layer that seals the neck, so it holds a lot of heat for its thickness. For deep cold, most people wear it with a neck gaiter over the top.'],
['What is it made of?','Breathable four-way stretch poly-spandex knit with a moisture-wicking face. The print is dyed into the fabric, so it does not crack, peel, or fade in the wash.'],
['Will it fit me?','One size fits most adults. The knit stretches a long way in both directions and pulls back to shape. If you wear a large helmet, it still fits.'],
['Can I breathe properly in it?','Yes. The mouth area is open knit, so you breathe through the fabric the same way you would through a gaiter.'],
['What is your return policy?','30 days, no questions asked. If it does not get a reaction on the first run, send it back.']
];

/* Masks 2 and 3 used to be pre-filled with Old Man Winter and Two Teeth Tony.
   Customers picked one face, never noticed the others, and received designs
   they did not choose. Now every mask the customer has not set themselves
   mirrors mask 1. touched[k] flips only on an explicit pick for that mask. */
var st={b:1,lines:[P[0].id,P[0].id,P[0].id],touched:[true,false,false]};
function mirror(){for(var i=1;i<st.lines.length;i++){if(!st.touched[i])st.lines[i]=st.lines[0];}}
function gp(id){for(var i=0;i<P.length;i++){if(P[i].id===id)return P[i];}return P[0];}
function idx(id){for(var i=0;i<P.length;i++){if(P[i].id===id)return i;}return 0;}
function q(){return st.b+1;}

/* ---- main gallery ---------------------------------------------------- */
var gRow=null,gLock=false,gTimer=null,gBuilt=false;
function arrowBtn(dir){
var b=el('button','position:absolute; top:50%; transform:translateY(-50%); '+(dir<0?'left:10px;':'right:10px;')+' width:40px; height:40px; border-radius:50%; border:none; background:rgba(18,22,28,0.82); color:#fff; cursor:pointer; z-index:6; display:none; align-items:center; justify-content:center; padding:0;','<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="'+(dir<0?'M15 5 8 12l7 7':'M9 5l7 7-7 7')+'"></path></svg>');
b.type='button'; b.setAttribute('aria-label',dir<0?'Previous design':'Next design');
return b;
}
function buildGallery(){
var box=g('if-mainbox');
if(!box||gBuilt)return;
box.style.position='relative';
gRow=el('div','display:flex; height:100%; width:100%; overflow-x:auto; scroll-snap-type:x mandatory; -webkit-overflow-scrolling:touch; scrollbar-width:none;');
gRow.id='if-gallery';
P.forEach(function(p,i){
var slide=el('div','flex:0 0 100%; width:100%; height:100%; scroll-snap-align:center; background:#E7EBEF;');
var im=el('img','width:100%; height:100%; object-fit:cover; display:block; pointer-events:none;');
im.src=p.img; im.alt=p.name; if(i>0)im.loading='lazy';
slide.appendChild(im); gRow.appendChild(slide);
});
box.innerHTML=''; box.appendChild(gRow);
var prev=arrowBtn(-1), next=arrowBtn(1);
box.appendChild(prev); box.appendChild(next);
function sync(){
var over=gRow.scrollWidth>gRow.clientWidth+8;
prev.style.display=(over&&gRow.scrollLeft>4)?'flex':'none';
next.style.display=(over&&gRow.scrollLeft+gRow.clientWidth<gRow.scrollWidth-4)?'flex':'none';
}
function step(d){gRow.scrollLeft+=d*gRow.clientWidth;setTimeout(sync,360);}
prev.onclick=function(e){e.preventDefault();step(-1);};
next.onclick=function(e){e.preventDefault();step(1);};
window.addEventListener('resize',sync);
gRow.addEventListener('scroll',function(){
sync();
clearTimeout(gTimer);
gTimer=setTimeout(function(){
if(gLock||!gRow.clientWidth)return;
var i=Math.round(gRow.scrollLeft/gRow.clientWidth);
if(P[i]&&P[i].id!==st.lines[0]){st.lines[0]=P[i].id;mirror();renderLabels();renderUnits();}
},130);
},{passive:true});
sync(); setTimeout(sync,250); setTimeout(sync,900);
gBuilt=true;
}
function renderLabels(){
var p=gp(st.lines[0]);
var n=g('if-name'); if(n)n.innerHTML=p.name;
var t=g('if-tag'); if(t)t.innerHTML=p.tag;
}
function renderMain(){
buildGallery();
if(gRow&&gRow.clientWidth){
var target=idx(st.lines[0])*gRow.clientWidth;
if(Math.abs(gRow.scrollLeft-target)>4){
gLock=true;
try{gRow.scrollTo({left:target,behavior:'smooth'});}catch(e){gRow.scrollLeft=target;}
setTimeout(function(){gLock=false;},450);
}
}
renderLabels();
}

function renderBundles(){
var w=g('if-bundles'); if(!w)return;
w.innerHTML='';
BUNDLES.forEach(function(b,i){
var on=i===st.b;
var e=el('button','position:relative; padding:16px 6px; border-radius:14px; cursor:pointer; text-align:center; font-family:Barlow,sans-serif; color:#12161C; border:2px solid '+(on?'#FF4D14':'#DDE3E9')+'; background:'+(on?'#FFF1EC':'#fff')+';','<div style="font-family:Bebas Neue, sans-serif; font-size:clamp(19px,4.4vw,24px); line-height:1; letter-spacing:0.5px;">'+b.qty+'</div><div style="font-size:11px; font-weight:600; opacity:0.75; margin-top:3px;">'+b.per+'</div><div style="font-weight:800; font-size:16px; margin-top:4px;">$'+b.price+'</div>'+(b.badge?'<div style="position:absolute; top:-10px; left:50%; transform:translateX(-50%); background:#FF4D14; color:#fff; font-size:9.5px; font-weight:800; padding:3px 9px; border-radius:999px; white-space:nowrap; letter-spacing:0.4px;">'+b.badge+'</div>':''));
e.type='button'; e.onclick=function(){st.b=i;render();};
w.appendChild(e);
});
}

function renderUnits(){
var w=g('if-units'); if(!w)return;
mirror();
var n=q(); w.innerHTML='';
for(var i=0;i<n;i++)(function(k){
var cur=gp(st.lines[k]);
var c=el('div','background:#fff; border:1.5px solid #DDE3E9; border-radius:16px; padding:11px;');
if(n>1){
var hint=(k>0&&!st.touched[k])?'<div style="font-size:11px; font-weight:600; color:#5B6672; line-height:1.3;">Same as mask 1 &middot; tap a face to change</div>':'';
c.appendChild(el('div','display:flex; align-items:center; gap:10px; margin-bottom:9px;','<img src="'+cur.img+'" alt="'+cur.name+'" style="width:38px; height:38px; object-fit:cover; border-radius:9px; flex-shrink:0;"><div style="min-width:0;"><div style="font-size:10px; font-weight:800; color:#FF4D14; letter-spacing:0.8px;">MASK '+(k+1)+' OF '+n+'</div><div style="font-size:15px; font-weight:700; color:#12161C; line-height:1.3;">'+cur.name+'</div>'+hint+'</div>'));
}
var grid=el('div','display:grid; grid-template-columns:repeat(3,1fr); gap:7px;');
P.forEach(function(p){
var on=p.id===st.lines[k];
var b=el('button','padding:4px 4px 6px; border-radius:11px; cursor:pointer; font-family:Barlow,sans-serif; border:2px solid '+(on?'#12161C':'#DDE3E9')+'; background:'+(on?'#12161C':'#fff')+';','<img src="'+p.img+'" alt="'+p.name+'" style="width:100%; aspect-ratio:1/1; object-fit:cover; border-radius:8px; pointer-events:none; display:block;"><div style="font-size:10px; font-weight:800; margin-top:5px; line-height:1.15; color:'+(on?'#fff':'#5B6672')+';">'+p.name+'</div>');
b.type='button'; b.title=p.name;
b.onclick=function(){st.lines[k]=p.id;st.touched[k]=true;if(k===0){render();}else{renderUnits();}};
grid.appendChild(b);
});
c.appendChild(grid);
w.appendChild(c);
})(i);
}

function render(){
mirror();
renderMain(); renderBundles(); renderUnits();
var t=g('if-total'); if(t)t.innerHTML=BUNDLES[st.b].price;
}

var rw=g('if-reviews');
if(rw){REVIEWS.forEach(function(r){
var stars=''; for(var i=0;i<5;i++){stars+=(i<parseInt(r[1],10))?'&#9733;':'&#9734;';}
rw.appendChild(el('div','background:#fff; border-radius:16px; padding:22px; border:1px solid #E3E8ED;','<div style="color:#FF4D14; font-size:15px; margin-bottom:8px; letter-spacing:2px;">'+stars+'</div><p style="font-size:15px; line-height:1.5; color:#2A323B; margin:0 0 14px;">&ldquo;'+r[2]+'&rdquo;</p><div style="font-weight:700; font-size:13px; color:#12161C;">'+r[0]+' <span style="color:#5B6672; font-weight:600;">&middot; Verified buyer</span></div>'));
});}

var fw=g('if-faqs');
if(fw){FAQS.forEach(function(f,i){
var d=el('div','border-bottom:1px solid #DDE3E9; padding:18px 0;');
var b=el('button','width:100%; display:flex; justify-content:space-between; align-items:center; gap:14px; background:none; border:none; cursor:pointer; padding:0; text-align:left; font-family:Barlow,sans-serif;','<span style="font-weight:700; font-size:16px; color:#12161C;">'+f[0]+'</span><span style="font-size:20px; color:#FF4D14; font-weight:800; flex-shrink:0;">'+(i===0?'&minus;':'+')+'</span>');
b.type='button';
var p=el('p','margin:12px 0 0; color:#5B6672; font-size:15px; line-height:1.6;'+(i===0?'':'display:none;'),f[1]);
b.onclick=function(){var open=p.style.display!=='none';p.style.display=open?'none':'block';b.querySelectorAll('span')[1].innerHTML=open?'+':'&minus;';};
d.appendChild(b); d.appendChild(p); fw.appendChild(d);
});}

/* ---- cart ------------------------------------------------------------ */
function setCount(n){var b=g('if-cart-count');if(!b)return;if(n>0){b.textContent=n;b.style.display='block';}else{b.style.display='none';}}
function refreshCount(){fetch('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){setCount(c.item_count);}).catch(function(){});}

var hdr=document.querySelector('#if > header');
var cartBtn=null;
if(hdr&&!g('if-cart-btn')){
cartBtn=el('button','position:relative; width:42px; height:42px; border-radius:11px; background:#12161C; border:none; color:#fff; cursor:pointer; display:flex; align-items:center; justify-content:center; flex-shrink:0;','<svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg><span id="if-cart-count" style="position:absolute; top:-4px; right:-4px; min-width:18px; height:18px; padding:0 4px; border-radius:999px; background:#12161C; color:#fff; font-size:11px; font-weight:800; line-height:18px; display:none; box-shadow:0 0 0 2px #FF4D14;">0</span>');
cartBtn.id='if-cart-btn'; cartBtn.type='button'; cartBtn.setAttribute('aria-label','Cart');
hdr.appendChild(cartBtn);
}
refreshCount();

var sg=g('if-sg'), sgOpen=g('if-sg-open');
if(sg&&sgOpen){
sgOpen.onclick=function(){sg.style.display='flex';};
Array.prototype.forEach.call(document.querySelectorAll('.if-sg-close'),function(b){b.onclick=function(){sg.style.display='none';};});
sg.onclick=function(e){if(e.target===sg)sg.style.display='none';};
}

function findVar(id){
var p=gp(id);
var v=V.filter(function(x){return x.option1===p.name;})[0];
return v||null;
}
function drawerSectionId(){
var host=document.querySelector('[id^="shopify-section"][id*="cart-drawer"]');
if(!host){var cd=document.querySelector('cart-drawer');if(cd)host=cd.closest('[id^="shopify-section"]');}
return host?host.id.replace('shopify-section-',''):null;
}
function openDrawer(sectionHtml){
var drawer=document.querySelector('cart-drawer');
if(!drawer){window.location.href='/cart';return;}
if(sectionHtml){try{
var fresh=new DOMParser().parseFromString(sectionHtml,'text/html').querySelector('cart-drawer');
if(fresh){drawer.className=fresh.className;drawer.innerHTML=fresh.innerHTML;}
}catch(e){}}
drawer.classList.remove('is-empty');
if(typeof drawer.open==='function'){try{drawer.open();}catch(e2){drawer.classList.add('animate','active');}}
else{drawer.classList.add('animate','active');}
document.body.classList.add('overflow-hidden');
refreshCount();
setTimeout(function(){
var d=document.querySelector('cart-drawer');
var cs=d?window.getComputedStyle(d):null;
if(!d||!cs||cs.visibility==='hidden'||cs.display==='none'){window.location.href='/cart';}
},900);
}
if(cartBtn){
cartBtn.onclick=function(){
var sid=drawerSectionId();
if(!sid){window.location.href='/cart';return;}
fetch('/?sections='+encodeURIComponent(sid),{headers:{'Accept':'application/json'},credentials:'same-origin'})
.then(function(r){return r.json();}).then(function(j){openDrawer(j[sid]);})
.catch(function(){window.location.href='/cart';});
};
}

var addBtn=g('if-add');
if(addBtn){
addBtn.onclick=function(){
var n=q(), e=g('if-err');
if(e)e.style.display='none';
mirror();
var items=[], missing=false;
for(var i=0;i<n;i++){var v=findVar(st.lines[i]);if(v&&v.id){items.push({id:v.id,quantity:1});}else{missing=true;}}
if(missing||!items.length){if(e){e.innerHTML='One of your faces is unavailable right now. Please pick another.';e.style.display='block';}return;}
var btn=this,label=btn.innerHTML;
btn.disabled=true; btn.innerHTML='Adding&hellip;';
var sid=drawerSectionId();
var body={items:items};
if(sid){body.sections=sid;body.sections_url=window.location.pathname;}
var guard=setTimeout(function(){window.location.href='/cart';},9000);
fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
.then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j};});})
.then(function(res){
clearTimeout(guard);
btn.disabled=false; btn.innerHTML=label;
if(!res.ok){throw new Error((res.j&&(res.j.description||res.j.message))||'Sold out or unavailable.');}
openDrawer((res.j&&res.j.sections&&sid)?res.j.sections[sid]:null);
})
.catch(function(err){
clearTimeout(guard);
btn.disabled=false; btn.innerHTML=label;
if(e){e.innerHTML=(err&&err.message)?String(err.message):'Could not add to cart. Please try again.';e.style.display='block';}
});
};
}

function fit(){
var w=g('if-imgwrap');
if(w)w.style.position=(window.innerWidth<820)?'static':'sticky';
}
window.addEventListener('resize',fit); fit();

render();
setTimeout(render,400);
setTimeout(render,1200);
})();
